///include /assets/js/app/p/support-articles/support-article.js
///include https://js.stackcdn.net/ajax/libs/lunr.js/2.3.8/lunr.min.js

"use strict"

/**
 * Article Flags
 *
 * - reseller{true} - when set to true article available exclusivly for resselers only
 * - reseller{false} - when set to false article should be available for both direct customers and resellers
 */

class SupportArticles {

    /**
     * @constructor
     * @param {boolean} reseller current user state
     */
    constructor(reseller = false) {
        this.searchIndex = null
        this.searchResults = null

        this.activeCategory = null
        this.allArticles = []
        this.limit = null
        this.articlesIds = null

        this.reseller = reseller

        this.getSupportArticles()
    }

    get articles() {
        let articles = this.allArticles.slice()

        if(this.activeCategory) {
            articles = articles.filter(a => a.categories.some(c => c.TitleUrl === this.activeCategory))
        }

        if(this.articlesIds) {
            articles = articles.filter(a => this.articlesIds.includes(a.entryId))
        }

        if(this.searchResults) {
            articles = this.searchResults.map(r => {
                let article = articles.find(a => a.entryId === Number(r.ref))

                if(article) {
                    for(const metadata in r.matchData.metadata) {
                        article.position = {}
                        for(const field in r.matchData.metadata[metadata]) {
                            article.position[field] = []
                            const position = r.matchData.metadata[metadata][field].position

                            position.forEach(p => {
                                article.position[field].push(p)
                            })
                        }
                    }

                    return article
                }
            })
        }

        return articles
    }

    markPosition(subject, criteria) {

    }

    /**
     * @return {PromiseLike}
     */
    getSupportArticles() {
        return $.ajax(`/a/supportGetArticles`)
            .then(r => {
                if(r) {
                    this.allArticles = this.assembleArticles(
                        this.filterByEntity(r)
                    )
                }
            }).then(() => {
                this.createIndex()
            })
    }

    /**
     * Discard not relevant articles
     *
     * @param {Array.<Object>} articles
     * @returns {Array.<Object>}
     */
    filterByEntity(articles) {
        if(!this.reseller) {
            return articles.filter(a => a.Reseller === false)
        }

        return articles
    }

    /**
     * Make a collection of articles from array of objects
     *
     * @param {Array.<Object>} articles
     * @returns {Array.<SupportArticle>}
     */
    assembleArticles(articles) {
        return articles.map(a => {
            return new SupportArticle(a)
        })
    }

    /**
     * Filter Articles by category title-url
     *
     * @param  {string} category
     * @param  {(number|null)} limit
     */
    filterByCategory(category, limit = null) {
        this.resetFilters()
        this.resetSearch()
        this.activeCategory = category
        this.limit = limit
    }

    /**
     * Filter articles by set of ids
     *
     * @param  {Array.<number>} array
     */
    filterByIds(array) {
        this.resetFilters()
        this.resetSearch()
        this.articlesIds = array
    }

    resetFilters() {
        this.articlesIds = null
        this.activeCategory = null
    }

    resetSearch() {
        this.searchResults = null
    }

    createIndex() {
        let articles = this.allArticles

        if(articles.length) {
            // @ts-ignore
            this.searchIndex = lunr(function() {
                this.ref("entryId")
                this.field("title")
                this.field("contentText")
                this.field("keywordsString")
                this.metadataWhitelist = ['position']

                articles.forEach(function(doc) {
                    this.add(doc)
                }, this)
            })
        }
    }

    /**
     * Search articles by query string
     *
     * @param  {string} query
     */
    find(query) {
        if(this.searchIndex && query && query !== "")  {
            this.resetFilters()
            let results = this.searchIndex.search(`${query}`).slice()
            if(!results.length) {
                results = this.searchIndex.search(`*${query}*`).slice()
            }
             this.searchResults = results
        }

        if(query === "") {
            this.resetSearch()
        }
    }

    /**
     * Search articles by query string and return results
     *
     * @param  {string} query
     * @param  {?int} limit Default 5
     * @return {Array.<SupportArticle>}
     */
    findAndReturn(query,limit = 5) {
        query = query.replaceAll('~', '')
        if(this.searchIndex && query && query !== "")  {
            let articles = this.allArticles.slice()
            let indexRes = this.searchIndex.search(query).slice()
            if(!indexRes.length) {
                indexRes = this.searchIndex.search(`*${query}*`).slice()
            }
            articles = indexRes.map(r => {
                return articles.find(a => a.entryId === Number(r.ref))
            })
            return articles.slice(0, limit)
        }

        if(query === "") {
            return []
        }

        return []
    }

    /**
     * Search articles by array of ids and return results
     *
     * @param  {Array.<number>} ids
     * @return {Array.<SupportArticle>}
     */
    findAndReturnByIds(ids) {
        if(this.searchIndex && ids && ids.length)  {
            let articles = this.allArticles.slice()
            return articles.filter(a => ids.includes(a.entryId))
        }

        return []
    }

    /**
     * Increment hit counter for given support article
     *
     * @param  {number} entryId Id of support article
     * @return {PromiseLike}
     */
    articleUpdateCounter(entryId) {
        return $.ajax({
            method: "post",
            url: `/a/supportUpdateCounter`,
            data: {
                id: entryId
            }
        })
    }

    /**
     * Save support article search query
     *
     * @param  {string} query Searched phrase
     * @return {PromiseLike}
     */
    searchStoreQuery(query) {
        return $.ajax({
            method: "post",
            url: `/a/supportStoreSearch`,
            data: {
                query: query,
                results: this.articles.length
            }
        })
    }
}
